import {request} from "./request";

export function getOneLeave() {
  return request({
    url: '/city/getOneLeave',
    params: {
    }
  })
}

export function getTwoLeave(id) {
  return request({
    url: '/city/getTwoLeave',
    params: {
      id: id
    }
  })
}

export class City {
  constructor(city) {
    this.id = city.id;
    this.label = city.name;
    this.value = city.name;
    // this.type = city.type
  }
}
